import { combineReducers } from "@reduxjs/toolkit";
import { UserData } from "./User/UserReducer";
import { ProjectData } from "./Projects/ProjectsReducer";
import { AdminData } from "./Admin/AdminReducer";

export default combineReducers({ UserData, ProjectData, AdminData });
